import { useCallback, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { Row, Col, Button, message, Popover } from 'antd';
import PatientFormCL from './PatientFormCL';
import SymbolsClass from './SymbolsClass';

const { format } = require('rut.js');

const PatientsAndServicesCL = ({
  form,
  type,
  patients,
  setPatients,
  totalPatients,
  setTotalPatients,
  currentPage,
  setDisabled,
  countrySettings,
  projects,
  setProjects,
}) => {
  const { t } = useTranslation();

  const checkPatients = useCallback(() => {
    let patientsDiff = totalPatients - patients.length;
    let _patients = [...patients];
    if (Math.sign(patientsDiff) === 1) {
      for (let i = 0; i < patientsDiff; i++) {
        _patients.push({ block: null, document_number: null, document_type: 'rut', phone: null, profession: null, prestations: [] });
      }
    }
    if (Math.sign(patientsDiff) === -1) {
      for (let i = 0; i < Math.abs(patientsDiff); i++) {
        _patients.pop();
      }
    }
    setPatients([..._patients]);
  }, [totalPatients]);

  useEffect(() => { checkPatients(); }, [checkPatients]);

  const updatePatientAttribute = (patientIndex, fieldName, value) => {
    const _patients = [...patients];
    let patient = _patients[patientIndex];
    if (fieldName === 'documentType') {
      patient.document_type = value;
      patient.document_number = '';
      _patients[patientIndex] = patient;
    } else if (!patient.document_type) {
      patient.document_type = 'rut';
    }
    if (fieldName === 'documentNumber') {
      patient.document_number = patient.document_type === 'rut' ? format(value) : value;
      _patients[patientIndex] = patient;
    }
    if (fieldName !== 'documentNumber' && fieldName !== 'documentType') {
      _patients[patientIndex][fieldName] = value;
    }
    if (fieldName === 'phone') {
      if (value === null || value === "" || value === "+") {
        _patients[patientIndex][fieldName] = null;
      } else {
        _patients[patientIndex][fieldName] = value;
      }
    }
    setPatients([..._patients]);
  };

  const updatePatientServices = (patientIndex, fieldName, service) => {
    let _patients = [...patients];
    _patients[patientIndex][fieldName] = service;
    setPatients([..._patients]);
  };

  const repeatServicesForAllPatients = () => {
    let _patients = [...patients];
    _patients.forEach((item) => { item['prestations'] = _patients[0]['prestations']; });
    setPatients([..._patients]);
  };

  const repeatLastPatientServices = (patientIndex) => {
    let _patients = [...patients];
    _patients[patientIndex]["prestations"] = _patients[patientIndex - 1]["prestations"];
    setPatients([..._patients]);
  };

  const addPatient = () => {
    if (patients.length === 100) {
      message.info({ content: t("reservations.patientsAndServices.disclaimerPatientMax"), style: { marginTop: "40vh" } });
      return null;
    }
    let _patients = [...patients];
    _patients.push({ block: null, document_number: null, document_type: 'rut', phone: null, profession: null, prestations: [] });
    setPatients([..._patients]);
    setTotalPatients(_patients.length);
  };

  const removePatient = (patientIndex) => {
    if (patients.length < 2) {
      message.error({ content: t("reservations.patientsAndServices.disclaimerPatient"), style: { marginTop: "30vh", fontSize: 16 } });
    } else {
      if (patientIndex > -1) {
        let _patients = [...patients];
        _patients.splice(patientIndex, 1);
        setPatients([..._patients]);
        setTotalPatients(_patients.length);
      }
    }
  };

  const repeatBlocksForAllPatients = () => {
    let _patients = [...patients];
    _patients.forEach((item) => {
      item['block'] = _patients[0]['block'];
      item['block_id'] = _patients[0]['block_id'];
    });
    setPatients([..._patients]);
  };

  const isReservationSettingsPage = currentPage?.includes('editar');

  return (
    <Row justify="center" className="reservation-settings-wrapper__patients-services mt-15">
      <Col lg={22} xs={22}>
        <Row><h2 className="mb-30">{t("reservations.patientsAndServices.title")}</h2></Row>
        <Row>
          {patients?.map((patient, index) => (
            <Col key={`${index}-patient`} lg={24} xs={24} className="patient-form-wrapper patient-form-wrapper--cl pt-10 pb-lg-0 pb-md-10 pb-sm-10 pb-xs-10 pl-20 pr-xs-20 pr-sm-20 pr-md-20 pr-lg-0 mb-20">
              <Row>
                <Col lg={3} xs={24} className="mt-lg-20">
                  <Row justify="center" align="middle" className="patient-index">
                    <Col><p className="mb-0 mr-15">{t("reservations.patientsAndServices.patientTitle")}&nbsp;{index + 1}</p></Col>
                    <Col><Popover content={<p className="mb-0">{patient.full_name}</p>} title="Nombre completo" placement="rightTop"><i className="icon-system-user" style={{ cursor: "pointer" }} /></Popover></Col>
                  </Row>
                  {isReservationSettingsPage && (
                    <div>
                      <Row justify="center">
                        <Col>
                          <p className="title-text mt-30 mr-40">{t("reservations.patientsAndServices.attendanceSubTitle")}</p>
                        </Col>
                      </Row>
                      <Row
                        justify="center"
                        className="symbols-key"
                        key={patient.id}
                      >
                        <Col className={patient.predict_percent === "Sin información" ? "mr-5" : "mr-10"}>
                          {patient.predict_percent === "Sin información" ? <div className="gray-state" />
                            :
                            SymbolsClass(patient.predict_percent)}
                        </Col>
                        <Col className={patient.predict_percent === "Sin información" ? "" : "mr-50"}>
                          <p className="text-label-sm">{patient.predict_category && patient.predict_category.charAt(0).toUpperCase() + patient.predict_category.slice(1)}</p>
                        </Col>
                      </Row>
                    </div>
                  )}
                </Col>
                <Col lg={20} xs={24}>
                  <PatientFormCL
                    reservationForm={form}
                    index={index}
                    patient={patient}
                    updatePatientAttribute={updatePatientAttribute}
                    updatePatientServices={updatePatientServices}
                    repeatServicesForAllPatients={repeatServicesForAllPatients}
                    repeatLastPatientServices={repeatLastPatientServices}
                    patients={patients}
                    totalPatients={totalPatients}
                    repeatBlocksForAllPatients={repeatBlocksForAllPatients}
                    type={type}
                    countryCode="CL"
                    setDisabled={setDisabled}
                    countrySettings={countrySettings}
                    projects={projects}
                    setProjects={setProjects}
                  />
                </Col>
                <Col xl={1} lg={1} xs={24} className="mt-lg-0 mt-md-20 mt-sm-20 mt-xs-20" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}><Button onClick={() => removePatient(index)} className="cmt-button secondary non-outline" type="primary"><span className='icon-system-delete' /></Button></Col>
              </Row>
            </Col>
          ))}
        </Row>
        <Row justify="end" className="mt-10"><Col><Button onClick={addPatient} className="cmt-button secondary outline" type="primary"><i className="icon-system-plus mr-10" />{t("reservations.patientsAndServices.addPatientButton")}</Button></Col></Row>
      </Col>
    </Row>
  );
};

export default PatientsAndServicesCL;
